import { connect } from "react-redux";
import Clients from "./Clients";
import {
  getClients,
  createClientRequest,
  updateClientRequest,
  deleteClientRequest,
} from "../../../store/actions/clients.actions";
import {
  clients,
  loading,
  loader,
  clientsPagination,
  getError,
} from "../../../store/selectors/clients.selector";

const mapDispatchToProps = {
  getClientsRequest: getClients,
  createClientRequest,
  updateClientRequest,
  deleteClientRequest,
};

const mapStateToProps = (state) => {
  const allClients = clients(state);
  const pageLoading = loading(state);
  const modalLoading = loader(state);
  const pagination = clientsPagination(state);
  const error = getError(state);
  return { error, pagination, allClients, modalLoading, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
